import { createSelector } from 'reselect';

// Selectors
import { getGUID } from 'store/reducers/userInteractions/selectors';
import {
  getVehicle,
  getServices,
  getDeclinedServices,
  getServicePointParams
} from 'store/reducers/appointment/selectors';

// Utils
import { isObjEmpty } from 'utils/varValidation';

const scheduleServiceProvider = 'Xtime Service Scheduler';

export const getShiftServiceStartObj = createSelector(getGUID, guid => {
  return {
    ScheduleServiceSessionId: guid,
    scheduleServiceProvider,
    events: 'scheduleServiceStart'
  };
});

export const getShiftServiceImpressionObj = createSelector(getGUID, guid => {
  return {
    scheduleServiceSessionId: guid,
    scheduleServiceProvider,
    events: 'scheduleServiceImpression'
  };
});

export const getShiftServiceApptSetObj = createSelector(
  getGUID,
  getVehicle,
  getServices,
  getDeclinedServices,
  getServicePointParams,
  (guid, vehicle, apptServices, declined, menus) => {
    const services = [];
    apptServices.forEach(service => {
      services.push({
        title: service.name,
        category: service.serviceKind,
        msrp: service.price
      });
    });
    declined.forEach(service => {
      services.push({
        title: service.name,
        category: 'repair',
        msrp: service.price
      });
    });
    if (!isObjEmpty(menus)) {
      services.push({
        title: menus.menuType.description,
        category: 'menuType',
        msrp: menus.menuType.price
      });
    }
    return {
      ScheduleServiceSessionId: guid,
      scheduleServiceProvider,
      serviceVehicleYear: vehicle.year,
      serviceVehicleMake: vehicle.make,
      serviceVehicleModel: vehicle.model,
      serviceVehicleVIN: vehicle.vin,
      serviceVehicleMileage: vehicle.mileage,
      services,
      events: 'scheduleServiceApptSet'
    };
  }
);



// WEBPACK FOOTER //
// ./src/store/reducers/clickTracking/selectors.js